export enum Environment {
    DEVELOPMENT = 'dev',
    STAGING = 'staging',
    TEST = 'test',
    PRODUCTION = 'production'
}
